import { render, staticRenderFns } from "./EditPermissions.admin.vue?vue&type=template&id=7c7673ec&scoped=true&lang=html&"
import script from "./EditPermissions.admin.vue?vue&type=script&lang=js&"
export * from "./EditPermissions.admin.vue?vue&type=script&lang=js&"
import style0 from "./EditPermissions.admin.vue?vue&type=style&index=0&id=7c7673ec&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7673ec",
  null
  
)

export default component.exports